import { Input } from "@xola/ui-kit";
import React, { ChangeEvent, useEffect, useState } from "react";

interface NumberInputProps {
    value?: number | null;
    placeholder?: string;
    onChange: (value?: any) => void;
    pattern?: RegExp;
    allowDecimal?: boolean;
    className?: string;
}

export const NumberInput = ({
    value,
    placeholder = "Enter a number",
    onChange,
    pattern,
    allowDecimal = false,
    className,
    ...rest
}: NumberInputProps) => {
    const [localValue, setLocalValue] = useState(value);

    useEffect(() => {
        if (localValue !== value) {
            /**
             * setting passed value in case they are inconsistent
             * (e.g. popover click outside case)
             */
            setLocalValue(value);
        }
    }, [value, localValue]);

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        let value;
        const regExp = pattern ?? /^(\d+(?:\.\d+)?)$/;
        if (regExp.test(inputValue)) {
            value = allowDecimal ? Number.parseFloat(inputValue) : Number.parseInt(inputValue, 10);
        }

        if (!value) {
            setLocalValue(value);
            // passing input value to handle error validation as it didn't pass the regex test.
            onChange(inputValue);
            return;
        }

        setLocalValue(value);
        onChange(value);
    };

    return (
        <Input
            type="number"
            placeholder={placeholder}
            value={localValue}
            pattern={pattern}
            className={className}
            onChange={handleInputChange}
            {...rest}
        />
    );
};
